import {Injectable} from "@angular/core";
import {HANDLER_FUNCTION, ITCIOrgChangeNotification, ITCIUserInfo, NavBarNotificationType} from "@tci/common";
import {Observable, Subject} from "rxjs";
import { NgUserService } from "./ng-user.service";

@Injectable()
export class NgOrgChangeNotificationService {

    constructor(private ngUserService: NgUserService) {
        this.handlers = {};
    }

    private static instance: NgOrgChangeNotificationService;

    private refreshSubject$ = new Subject<ITCIOrgChangeNotification>();
    private navbar: any;
    private handlers: { [id: string]: HANDLER_FUNCTION<any> };

    public static getInstance(ngUserService: NgUserService): NgOrgChangeNotificationService {
        if (!NgOrgChangeNotificationService.instance) {
            NgOrgChangeNotificationService.instance = new NgOrgChangeNotificationService(ngUserService);
        }
        return NgOrgChangeNotificationService.instance;
    }

    getRefreshSubject(): Subject<ITCIOrgChangeNotification> {
        return this.refreshSubject$;
    }

    public subscribeNavBarNotifications(notification: NavBarNotificationType): Observable<ITCIOrgChangeNotification> {
        if (this.navbar) {
            // tslint:disable:max-line-length
            // https://confluence.tibco.com/pages/viewpage.action?spaceKey=UT&title=Usage%3A+Global+Navigation+Header#Usage:GlobalNavigationHeader-Events
            /**
             * When app list aggregated for Scribe and TCI apps what is common is the TSC  JWT , which is used on
             * scribe
             * session creation . The session creation returns a Scribe OrgId and this is cached on a encrypted browser
             * cookie from WS. So If I understand it correctly the scribe OrgId from JTSC WT(Org1) is different from
             * TSC JWT(Org2) which means the scribe cookie (prev orgId) needs to be invalidated on Org Change. This
             * will force the server side to create a new scribe session with new OrgId to be saved in the cookie
             * again. org chang => goes to app list meanwhile the event handler deletes the cookie, the backend when it
             * does not see the cookie will establish a new session with a different cookie with new orgid, so in the
             * end the cookie will be different in the browser( ScribeSession)
             */
            if (!this.handlers[notification]) {
                this.handlers[notification] = (...args: any) => {
                    this.ngUserService.getUserInfo(true).subscribe((userinfo: ITCIUserInfo) => {
                        this.refreshSubject$.next({notification, data: [...args], userinfo});
                    });
                };
                this.navbar.subscribeEvent(notification, this.handlers[notification]);
            }
        }
        return this.refreshSubject$.filter(res => res.notification === notification);
    }

    setNavbar(navbar: any) {
        this.navbar = navbar;
    }

}
